import { StyleSheet } from 'react-native';
import { PALETTE, SIZES, MQ_TABLET } from '../../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({
  chartTitle: {
    marginTop: 15,
    marginBottom: 15,
    marginLeft: SIZES.appHorizontalSpace,
  },
  timechartWrapper: {
    flex: 1,
    paddingBottom: 20,
    backgroundColor: '#12213c',
  }
}, {
	[MQ_TABLET]:{
	  timechartWrapper: {
      flex: 0.5,
      backgroundColor: '#12213c',
	  }
	}
});

export const axisSVGStyles = {
  color: PALETTE.secondaryText,
  stroke: PALETTE.secondaryText,
};
